export const keysToListFromMap = <T>(keys: string[], map: { [key: string]: T }): T[] => keys.map(key => map[key]);

export const tryKeysToListFromMap = <T>(
  keys?: string[],
  map?: { [key: string]: T },
  defaultResult: T[] | undefined = undefined,
): T[] | undefined => (map ? keys?.map(key => map[key]) ?? defaultResult : defaultResult);
